var wFlag=true
if(window.innerWidth<750){
    wFlag=false
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 300);

    var box2Video = wFlag?$('.video_mask video')[0]:$('.video_mask video')[1]
    $('.box2_text span').click(function(){
        box2Video.play()
        $('.video_mask').fadeIn()
    })

    $('.video_mask img').click(function(){
        box2Video.pause()
        $('.video_mask').fadeOut()
    })

    //box2
    ScrollTrigger.create({
        trigger:'.box2',
        start:'top top+=4%',
        end:'+=100%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to({},{duration:0.2})
            .from('.box2_bg',{scale:1,borderRadius:0,opacity:1})
            .to('.box2_text p',{opacity:1,stagger:0.2})
            .from('.box2_text span',{opacity:0})
            .to({},{duration:0.2})
    })

    //box3
    // showUp('.box3_title')
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_item div p').removeClass('box3Active')
                $('.box3_item div').eq(index).find('p').addClass('box3Active')
            }
        },
    })
    $('.box3_item div').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })

    //box2_1
    ScrollTrigger.create({
        trigger:'.box2_1',
        start:'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{y:'2rem',opacity:0,stagger:0.2})
    })

    //box4
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top center-=30%',
            end:'+=70%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_bg',{clipPath:'inset(40% round 1rem)'})
                .to('.box4_text1',{x:'-185%'},'<')
                .to('.box4_text2',{x:'175%'},'<')
                .to('.box4_info',{opacity:1})
        })
    }else{
        showUp('.box4_title')
    }
    ScrollTrigger.create({ 
        trigger:'.box4',
        start:wFlag?'top+=80% center-=30%':'top+=10% top+=5%',
        end:'+=60%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            $('.box4_info1').toggleClass('box4Active',index<20)
            $('.box4_info2').toggleClass('box4Active',index>=20)
            $('.box4').toggleClass('box4Active1',index>=80)
        }
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=5%',
        end:wFlag?'+=150%':'+=100%',
        pin:true
    })

    //box5
    $('.box5_video').on('ended', function() {
        $('.box5_info').css({opacity:1});
    });
    if(wFlag){
        var $video = $('.box5_video1');
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=20% top+=5%',
            end:'+=150%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 3.36;
                
            }
        })
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=180% top+=5%',
            end:'+=100%',
            scrub:true,
            onUpdate: function (self) {
                let index = Math.floor(self.progress * 100);
                $('.box5_left').toggleClass('opacity1',index>=5)
                $('.box5_1').toggleClass('box5Active',index>=40)
                $('.box5_1').toggleClass('box5Active1',index>=80)
            }
        })

        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=10% top+=5%',
            end:'+=10%',
            scrub:true,
            animation:gsap.timeline()
                .from('.box5_1',{opacity:0})
        })

        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=5%',
            end:'+=300%',
            pin:true
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box5_1',
            start:'top center',
            end:'+=0%',
            // once: true,
            onEnter: () => {
                $('.box5_video2')[0].play()
            }
        })

        ScrollTrigger.create({
            trigger:'.box5_1',
            start:'top+=10% top+=5%',
            end:'+=100%',
            scrub:true,
            onUpdate: function (self) {
                let index = Math.floor(self.progress * 100);
                $('.box5_left').toggleClass('opacity1',index>=5)
                $('.box5_1').toggleClass('box5Active',index>=40)
                $('.box5_1').toggleClass('box5Active1',index>=80)
            }
        })

        ScrollTrigger.create({
            trigger:'.box5_1',
            start:'top top+=5%',
            end:'+=150%',
            pin:true
        })
    }

    //box6
    showUp('.box6_title')
    showUp('.box7_title')
    showUp('.box8_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top center',
            end:'+=80%',
            scrub:1,
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box8_item div:nth-child(1)',{x:'-60%',opacity:0})
                .from('.box8_item div:nth-child(2)',{x:'60%',opacity:0})
                .from('.box8_item div:nth-child(3)',{x:'-60%',opacity:0})
        })
    }

    //box9
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top center-=30%',
            end:'+=70%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box9_bg',{clipPath:'inset(43% 37% 39% 45% round 1rem)'})
                .to('.box9_text1',{x:'-220%'},'<')
                .to('.box9_text2',{x:'190%'},'<')
                .from('.box9_title',{opacity:0})
        })
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=5%',
            end:wFlag?'+=80%':'+=100%',
            pin:true
        })
    }else{
        showUp('.Mbox9_title')
    }

    //box10
    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        autoplay: true,
        slidesPerView: wFlag?2:1,
        centeredSlides: true,
        pagination: {
            el: '.box10_bar .swiper-pagination',
            clickable :true,
        },
    })
    showUp('.box11_title')
    showUp('.box11_info')

    //box12
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box12',
            start:'top top+=10%',
            end:'+=130%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box12_item',{clipPath:'inset(25% 15% 48% 54% round 1rem)'})
                .to('.box12_text1',{x:'-125%'},'<')
                .to('.box12_text2',{x:'162%'},'<')
                .from('.box12_img',{y:'25%'})
                .from('.box12_title,.box12_info,.box12_tips',{opacity:0})
                .to('.box12_img img:last-child',{opacity:1})
        })
    }else{
        showUp('.Mbox12_title')
        ScrollTrigger.create({
            trigger:'.box12',
            start:'top+=10% top+=3%',
            end:'+=20%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box12_img img:last-child',{opacity:1})
        })
    }
    ScrollTrigger.create({
        trigger:'.box12',
        start:'top top+=3%',
        end:wFlag?'+=160%':'+=50%',
        pin:true
    })

    //box13
    showUp('.box13_title')
    ScrollTrigger.create({
        trigger:'.box13',
        start:'top+=20% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box13_flag',{opacity:0})
            .from('.box13_text',{opacity:0,y:'2rem'})
    })
    ScrollTrigger.create({
        trigger:'.box13',
        start:wFlag?'top+=80% top+=4%':'top+=120% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box13_img',{opacity:0})
            .from('.box13_info',{opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box13',
        start:wFlag?'top+=120% top+=4%':'top+=200% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box13_flag1',{opacity:0})
            .from('.box13_item',{x:'100%'},'-=50%')
    })

    ScrollTrigger.create({
        trigger:'.box13',
        start:'top top+=4%',
        end:wFlag?'+=160%':'+=200%',
        pin:true
    })


    //box14
    showUp('.box14_title')
    new Swiper('.box14Swiper', {
        autoplay: {
            disableOnInteraction: true,
            delay: 1500,
        },
        slidesPerView:wFlag?5:3,
        centeredSlides: true,
        slideToClickedSlide: true,
    })
    new Swiper('.box14Swiper1', {
        autoplay: {
            disableOnInteraction: true,
            delay: 1500,
        },
        slidesPerView:wFlag?5:3,
        centeredSlides: true,
        slideToClickedSlide: true,
    })

    $('.box14_btn div').click(function(){
        var index = $(this).index()
        $(this).addClass('box14Active').siblings().removeClass('box14Active')
        $('.box14_items .box14_item').eq(index).addClass('box14Active1').siblings().removeClass('box14Active1')
    })
    ScrollTrigger.create({
        trigger:'.box14',
        start:'top+=20% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box14_flag,.box14_img,.box14_bg img:last-child',{opacity:0})
            .to('.box14_bg',{y:'-5%',scale:1})
            .from('.box14_title2,.box14_items,.box14_btn',{opacity:0})
    })

    ScrollTrigger.create({
        trigger:'.box14',
        start:'top top+=4%',
        end:wFlag?'+=100%':'+=80%',
        pin:true
    })

    new Swiper('.box15Swiper', {
        autoplay: true,
        slidesPerView: wFlag?1.5:1,
        centeredSlides: true,
        pagination: {
            el: '.box15_bar .swiper-pagination',
            clickable :true,
        },
    })

    //box16
    showUp('.box16_title')
    new Swiper('.box16Swiper2', {
        autoplay:true,
        //effect: wFlag?'slide':'fade',
        pagination: {
            el: '.box16Swiper2-pagination',
            clickable:true
        }
    })

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
})



$('.fr_item').click(function(){
    $('.fr_item').css({border:'1px solid #333'})
    $('.fr_title').children('.fri_right').children('.fri_line').removeClass('fri_active')
    $('.fr_item').children('.fr_text').css({height:'0',margin:'0'})

    $(this).css({border:'1px solid #666'})
    var Toheight = $(this).children('.fr_text')[0].scrollHeight
    var heightFlag = $(this).children('.fr_text').css('height')
    if(heightFlag == '0px'){
        $(this).children('.fr_title').children('.fri_right').children('.fri_line').addClass('fri_active')
        $(this).children('.fr_text').css({height:`${Toheight}px`})
    }else{
        $(this).children('.fr_title').children('.fri_right').children('.fri_line').removeClass('fri_active')
        $(this).children('.fr_text').css({height:'0',margin:'0'})
    }
})

var faq_flag = true
$('.faq_btn').click(function(){
    if(faq_flag){
        $('.fr_items .fr_item:nth-child(n+6)').css({display:'block'})
        $(this).text('Show Less')
    }else{
        $('.fr_items .fr_item:nth-child(n+6)').css({display:'none'})
        $(this).text('Learn More')
    }
    faq_flag = !faq_flag
})


//boxSpecs_btn
$('.bs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
   window.open('https://store.oxva.com/products/oxva-xlim-pro-4'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})